import React from 'react';
import PanelHeader from '../PanelHeader';
import { useEditor } from '../EditorContext';
import { SHAPE_CATALOG } from '../constants';
import {
  addRect,
  addCircle,
  addTriangle,
  addEditableGroup,
  addEntryField,
  addOrgBanner,
  setObjectFill,
} from '../../canvasEditor';

const ADDERS = {
  circle: (fc) => addCircle(fc),
  rect: (fc) => addRect(fc),
  triangle: (fc) => addTriangle(fc),
  editable: (fc) => addEditableGroup(fc),
  entryfield: (fc) => addEntryField(fc),
  orgbanner: (fc) => addOrgBanner(fc),
};

export default function ShapesPanel() {
  const { fabricRef, selection, refreshLayers } = useEditor();
  const isShape =
    selection
    && (selection.niceName === 'shape' || selection.name === 'shape' || selection.name === 'editable' || selection.name === 'entryfield')
    && !String(selection.niceName || '').startsWith('button');

  const addShape = (id) => {
    const fc = fabricRef.current;
    const fn = ADDERS[id];
    if (!fc || !fn) return;
    fn(fc);
    refreshLayers?.();
  };

  const onFill = (e) => {
    if (!selection) return;
    setObjectFill(selection, e.target.value);
    fabricRef.current?.renderAll();
  };

  return (
    <div className="pixie-panel">
      <PanelHeader title="Shapes" icon="fa-shapes" />
      <div className="pixie-shape-grid">
        {SHAPE_CATALOG.map((shape) => (
          <button
            key={shape.id}
            type="button"
            className="pixie-shape-tile"
            onClick={() => addShape(shape.id)}
          >
            <i className={`fa-solid fa-${shape.id === 'circle' ? 'circle' : shape.id === 'triangle' ? 'play' : 'square'}`} />
            <span>{shape.label}</span>
          </button>
        ))}
      </div>

      {isShape && (
        <div className="pixie-props">
          <PanelHeader title="Fill" icon="fa-fill-drip" />
          <label className="pixie-field">
            Color
            <input type="color" onChange={onFill} defaultValue="#008000" />
          </label>
        </div>
      )}
    </div>
  );
}
